import * as Yup from "yup";


export const taskAutomationSchema = Yup.object().shape({
  eventType: Yup.object().shape({
    label: Yup.string().required("Required"),
    value: Yup.string().required("Required"),
  }),
  clergyType: Yup.object().shape({
    label: Yup.string().required("Required"),
    value: Yup.string().required("Required"),
  }),
  // subject: Yup.string().required("Required"),
  text: Yup.string().required("Required"),
});
